(function () {
  if (window.__ALT_CTA_LOADED__) return;
  window.__ALT_CTA_LOADED__ = true;

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function getContainer() {
    return qs("#alternate_flex_box");
  }

  function getSelectedOptionValue() {
    const checked = qs('.variant-picker__form input[type="radio"][data-variant-id]:checked');
    if (checked && checked.value) return checked.value.trim();

    const checkedAny = qs('input[type="radio"][data-variant-id]:checked');
    if (checkedAny && checkedAny.value) return checkedAny.value.trim();

    return null;
  }

  function getRefQty(container, opt) {
    const pack = Number(container.dataset.refQtyPack || 1);
    const strip = Number(container.dataset.refQtyStrip || 1);
    return (opt && opt.toLowerCase() === "strip") ? strip : pack;
  }

  function getMoneyFormat(container) {
    try { return JSON.parse(container.dataset.moneyFormat || '"{{amount}}"'); }
    catch (e) { return "{{amount}}"; }
  }

  function formatMoney(cents, container) {
    const fmt = getMoneyFormat(container);
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, fmt);
    }
    const val = (Number(cents || 0) / 100).toFixed(2);
    return fmt.replace("{{amount}}", val).replace("{{amount_no_decimals}}", String(Math.round(Number(cents || 0) / 100)));
  }

  function updateVariantCardPrices(container) {
    qsa('.alternate_items[data-product-type="variant"]', container).forEach((card) => {
      const priceCents = Number(card.dataset.price || 0);
      const compareCents = Number(card.dataset.compare || 0);

      const priceEl = qs(".js-var-price", card);
      const compareEl = qs(".js-var-compare", card);

      if (priceEl) priceEl.textContent = formatMoney(priceCents, container);

      if (compareEl) {
        if (compareCents > priceCents) {
          compareEl.style.display = "";
          compareEl.textContent = formatMoney(compareCents, container);
        } else {
          compareEl.style.display = "none";
          compareEl.textContent = "";
        }
      }
    });
  }

  function updateSimpleCards(container, opt) {
    const refQty = getRefQty(container, opt);

    qsa('.alternate_items[data-product-type="simple"]', container).forEach((card) => {
      // Ensure simple is always visible + active (so modal builder can pick it)
      card.style.display = "block";
      card.classList.add("active_alternate");

      const unit = Number(card.dataset.unitPrice || 0);
      const unitCompare = Number(card.dataset.unitCompare || 0);

      const totalCents = Math.round(unit * refQty * 100);
      const compareCents = Math.round(unitCompare * refQty * 100);

      const priceEl = qs(".js-alt-price", card);
      const compareEl = qs(".js-alt-compare", card);

      if (priceEl) priceEl.textContent = formatMoney(totalCents, container);

      if (compareEl) {
        if (unitCompare > unit) {
          compareEl.style.display = "";
          compareEl.textContent = formatMoney(compareCents, container);
        } else {
          compareEl.style.display = "none";
          compareEl.textContent = "";
        }
      }
    });
  }

  function showMatchingVariants(container, opt) {
    qsa('.alternate_items[data-product-type="variant"]', container).forEach((card) => {
      card.style.display = "none";
      card.classList.remove("active_alternate");
    });

    if (!opt) return;

    const escaped = (window.CSS && CSS.escape) ? CSS.escape(opt) : opt.replace(/"/g, '\\"');
    const matching = qsa(`.alternate_items[data-product-type="variant"][data-variant-value="${escaped}"]`, container);

    matching.forEach((card) => {
      card.style.display = "block";
      card.classList.add("active_alternate");
    });
  }

  function refreshAlternates() {
    const container = getContainer();
    if (!container) return;

    const opt = getSelectedOptionValue();
    if (!opt) return;

    updateVariantCardPrices(container);
    showMatchingVariants(container, opt);
    updateSimpleCards(container, opt); // IMPORTANT: keeps simple always active + recalculated
  }

  document.addEventListener("DOMContentLoaded", refreshAlternates);

  document.addEventListener("change", (e) => {
    if (e.target && e.target.matches('.variant-picker__form input[type="radio"][data-variant-id]')) {
      refreshAlternates();
    }
  });

  document.addEventListener("variant:change", refreshAlternates);
  document.addEventListener("product:variant-change", refreshAlternates);

  document.addEventListener("click", (e) => {
    const btn = e.target.closest && e.target.closest("#modal_alternative");
    if (btn) refreshAlternates();
  });

})();
